import { ESTADO_BADGES, DEFAULT_VALUES } from '../../../core/constants';

export const getEstadoBadge = (estado) => {
  return ESTADO_BADGES[estado] || 'secondary';
};

export const getNombreProcesador = (idProcesador, procesadores) => {
  if (!idProcesador) return null;
  const procesador = procesadores.find(p => p.id === idProcesador);
  return procesador?.usuario1 || null;
};

export const contarEstados = (turnos) => {
  const conteo = {};
  if (!Array.isArray(turnos)) return conteo;
  turnos.forEach(turno => {
    const estado = turno.estadosTurno?.estadoTurno || 'Sin estado';
    conteo[estado] = (conteo[estado] || 0) + 1;
  });
  return conteo;
};

export const buildTurnosRequestBody = (filtros) => {
  const tiposEquipo = [];
  if (filtros.equipo) {
    // Soportar múltiples ids separados por coma (cuando se agrupa por nombre)
    filtros.equipo.split(',').forEach(id => tiposEquipo.push(id.trim()));
  }
  if (filtros.equipoCPAP) {
    filtros.equipoCPAP.split(',').forEach(id => tiposEquipo.push(id.trim()));
  }

  return {
    fechaEntregaDesde: `${filtros.fechaDesde}T00:00:00`,
    fechaEntregaHasta: `${filtros.fechaHasta}T23:59:59`,
    idCentro: filtros.centro ? parseInt(filtros.centro) : DEFAULT_VALUES.ID_ALL,
    idTipoEstudio: filtros.tipoEstudio ? parseInt(filtros.tipoEstudio) : DEFAULT_VALUES.ID_ALL,
    idEstadoTurno: filtros.estadoTurno ? parseInt(filtros.estadoTurno) : DEFAULT_VALUES.ID_ALL,
    idTurno: filtros.idHorario ? parseInt(filtros.idHorario) : DEFAULT_VALUES.ID_ALL,
    idProcesador: filtros.procesador ? parseInt(filtros.procesador) : DEFAULT_VALUES.ID_ALL,
    mostrarEnviados: filtros.mostrarEnviados,
    nombre: filtros.nombre || DEFAULT_VALUES.EMPTY_STRING,
    idCategoria: filtros.categoria ? parseInt(filtros.categoria) : DEFAULT_VALUES.ID_ALL,
    idObraSocial: filtros.obraSocial ? parseInt(filtros.obraSocial) : DEFAULT_VALUES.ID_ALL,
    tiposEquipo: tiposEquipo,
    canal: filtros.canales ? parseInt(filtros.canales) : DEFAULT_VALUES.ID_ALL,
  };
};
